import React from "react"
import DashboardContainer from "../components/dashboard/DashboardContainer"

const DashboardPage: React.FC = () => {

    return <DashboardContainer />

}

export default DashboardPage
